import { render, staticRenderFns } from "./AITutorSystem.vue?vue&type=template&id=27b9ac40&scoped=true&"
import script from "./AITutorSystem.vue?vue&type=script&lang=js&"
export * from "./AITutorSystem.vue?vue&type=script&lang=js&"
import style0 from "./AITutorSystem.vue?vue&type=style&index=0&id=27b9ac40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b9ac40",
  null
  
)

export default component.exports